import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/writer/x-tinymce.js';
import { CampusExercise } from '@chancenwerk/campus-learning-content/entities/CampusExercise.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-campus-loader.js';
import '@chancenwerk/design/components/cr-image.js';
import '@chancenwerk/design/components/cr-input.js';
import '@chancenwerk/design/components/cr-writer/cr-writer.js';
import '@chancenwerk/design/components/fonts.js';
import { html, type PropertyValueMap } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { switchMap } from 'rxjs';
import SmilesDrawer from 'smiles-drawer/src/SmilesDrawer';

@customElement('campus-component-exercise-chemistry-formula')
export class CampusComponentExerciseChemistryFormula extends ChemistryLitElement {
  @state() exerciseID = new RXController<string>(this, '');
  @state() lessonID = new RXController<string>(this, '');

  @state() private readonly _content = new RXController(
    this,
    this.exerciseID.observable.pipe(
      switchMap(contentID => CampusExercise.subscribeByID<CampusExercise>(contentID)(CampusExercise.allFields)),
    ),
  );

  override updated(changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.updated(changedProperties);
    if (this._content.value?.chemistryFormula) {
      const svgTarget = this.shadowRoot?.querySelector('#formulaSVG');
      const drawer = new SmilesDrawer();
      drawer.draw(this._content.value.chemistryFormula, svgTarget);
    }
  }

  override render() {
    if (!this.exerciseID.value.length) {
      return html`
        <cr-flex space="md" center crossaxis-center ${css({ height: '100%' })}>
          <cr-text>Inhalt nicht verfügbar.</cr-text>
        </cr-flex>
      `;
    }

    if (this._content.isLoading) {
      return html`
        <cr-flex space="md" center crossaxis-center ${css({ height: '100%' })}>
          <cr-campus-loader></cr-campus-loader>
        </cr-flex>
      `;
    }

    return html`
      <cr-flex ${css({ height: '100%' })}>
        <svg id="formulaSVG"></svg>
      </cr-flex>
    `;
  }
}
